<template>
  <div class="as-lineups">
    <div class="as-team">
      <div class="as-team-item">
        <img
          :src="getImgUrlBySport('team', match?.home_team?.id)"
          :alt="match?.home_team?.name"
          :title="match?.home_team?.name"
        />
        <div class="as-name">{{ match?.home_team?.name }}</div>
      </div>
      <div class=" as-team-item as-team-item-away">
        <div class="as-name">{{ match?.away_team?.name }}</div>
        <img
          :src="getImgUrlBySport('team', match?.away_team?.id)"
          :alt="match?.away_team?.name"
          :title="match?.away_team?.name"
        />
      </div>
    </div>
    <div class="as-content">
      <div v-for="(item, key) in datas" :key="key" class="as-lineup-item">
        <div class="as-lineup-item-left as-d-flex as-flex-column as-justify-content-center">
          <img
            :src="item.home_player_id ? getImgUrlBySport('player', item.home_player_id) : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAq1BMVEUAAADz+//y+//////z+//y+v/z+v/z+//z+//z+v/0+//z/P/4///z///y+v/c5/T79e7u9v54krz269/m7/nj7vjs9fzf6vbr8fjp8Pfp8vvt6uiDm8G8xdewvNKfsMt8lr7z9fXO2OePpMbu7/Dy7uvn5uemt9Gks8yUqMmZq8jz+Pvc5vDY4u/18On17ubi4uXE0eXw6eLEzNq2xdrY2uDN0t3W09S+ws6rjEyiAAAADnRSTlMAgPML6NnTv6qlclIjFjy9diYAAAH+SURBVDjLnZXpeqsgEEDV7NsgCGLUGNM0a3vb3rZ3ef8nKxBwoPvX80vhMAMIYxQyn05GgyQZjCbTefQhi3gICqoAxTBevKv14gQgF8QicoAk7r31Zn2gXAu8zPOSC/1IoT977cUA3IRxmGEcIA7TjoFKHSGACiIpjP30Y8gJwWio6taxn5fqsRfEYXt6ps6UJMfsM+3ZHn5ihsapklCY2Qn2zZvhV8ssdd5lh37PJuYktx5DanAmvyRfJECEbTywdmus9ZGxKzdpQpOFDUjt4Jo9pNVTs3pI07/s3IUUJuQQA96yVdpxZNQtkMBQnRfIux28qlNkz3gXsoR5NNUDnLhOPWqXSKecRhOQohMbXzxx6JYDk2gExDVssp0vVtkGJzmKBihmWRqQ3duOktBBlKipfiRmYNDLTT4V7zzRT31zH4p3N15qXIxmta6cpR4BvMUE2wPP7MmJdbsBf3uCDQfZ1vuL17ADgL/h+AkNv1m72qe7P2e2NY34Ce2hQLNmhrVpw0OBx8xR/T9uz80/N0E8ZnhwDWWVGa5LgODghleB82JnxUKU3lUILxcVxXJ5fRHV01Lg5QquK5WqV5JH7VVEvRQSr6tXALSnq9Tto/YUBS8EFgAsKbqDBKgEWFK8IiWd55BLLFJh2XtFWPbCQopgIf1Zaf662H/79/ECjIFUYeI1OcEAAAAASUVORK5CYII='"
            class="as-player-img"
          />
          <div class="as-player-name">{{  item.home_player_name }}</div>
        </div>
        <div class="as-line-box">
          <div class="as-line1">
            <div class="as-line1-text" :style="{
              bottom: item.home > 0 || item.away > 0 ? `${item.home + 5}px` : ''
            }">
              {{ item.home > 0 || item.away > 0 ? item.home : '' }}
            </div>
            <div class="as-line1-bar" :style="{
              height: item.home > 0 || item.away > 0 ? `${item.home}px` : ''
            }"></div>
          </div>
          <div class="as-line2">
            <div class="as-line1-text" :style="{
              bottom: item.home > 0 || item.away > 0 ? `${item.away + 5}px` : ''
            }">
              {{ item.home > 0 || item.away > 0 ? item.away : '' }}
            </div>
            <div class="as-line2-bar" :style="{
              height: item.home > 0 || item.away > 0 ? `${item.away}px` : ''
            }"></div>
          </div>
          <div class="as-line3"></div>
          <div class="as-points">{{ item.title }}</div>
        </div>
        <div class="as-lineup-item-right as-d-flex as-flex-column as-justify-content-center">
          <img
            :src="item.away_player_id ? getImgUrlBySport('player', item.away_player_id) : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAq1BMVEUAAADz+//y+//////z+//y+v/z+v/z+//z+//z+v/0+//z/P/4///z///y+v/c5/T79e7u9v54krz269/m7/nj7vjs9fzf6vbr8fjp8Pfp8vvt6uiDm8G8xdewvNKfsMt8lr7z9fXO2OePpMbu7/Dy7uvn5uemt9Gks8yUqMmZq8jz+Pvc5vDY4u/18On17ubi4uXE0eXw6eLEzNq2xdrY2uDN0t3W09S+ws6rjEyiAAAADnRSTlMAgPML6NnTv6qlclIjFjy9diYAAAH+SURBVDjLnZXpeqsgEEDV7NsgCGLUGNM0a3vb3rZ3ef8nKxBwoPvX80vhMAMIYxQyn05GgyQZjCbTefQhi3gICqoAxTBevKv14gQgF8QicoAk7r31Zn2gXAu8zPOSC/1IoT977cUA3IRxmGEcIA7TjoFKHSGACiIpjP30Y8gJwWio6taxn5fqsRfEYXt6ps6UJMfsM+3ZHn5ihsapklCY2Qn2zZvhV8ssdd5lh37PJuYktx5DanAmvyRfJECEbTywdmus9ZGxKzdpQpOFDUjt4Jo9pNVTs3pI07/s3IUUJuQQA96yVdpxZNQtkMBQnRfIux28qlNkz3gXsoR5NNUDnLhOPWqXSKecRhOQohMbXzxx6JYDk2gExDVssp0vVtkGJzmKBihmWRqQ3duOktBBlKipfiRmYNDLTT4V7zzRT31zH4p3N15qXIxmta6cpR4BvMUE2wPP7MmJdbsBf3uCDQfZ1vuL17ADgL/h+AkNv1m72qe7P2e2NY34Ce2hQLNmhrVpw0OBx8xR/T9uz80/N0E8ZnhwDWWVGa5LgODghleB82JnxUKU3lUILxcVxXJ5fRHV01Lg5QquK5WqV5JH7VVEvRQSr6tXALSnq9Tto/YUBS8EFgAsKbqDBKgEWFK8IiWd55BLLFJh2XtFWPbCQopgIf1Zaf662H/79/ECjIFUYeI1OcEAAAAASUVORK5CYII='"
            class="as-player-img"
          />
          <div class="as-player-name">{{ item.away_player_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { ILineups, IMatch, IPlayer } from "~src/interfaces/basketball";
import { getTotalScore } from "~src/helpers/basketball";
import { convertLineupsPlayer } from "~src/helpers/basketball/LineupHelper";

interface IProps {
  lineups: ILineups;
  match: IMatch;
}

interface IData {
  title: string;
  home: number;
  away: number;
  home_player_id: string | null;
  home_player_name: string | null;
  away_player_id: string | null;
  away_player_name: string | null;
}

const props = withDefaults(defineProps<IProps>(), {});

const getParcent = (homeVal: number, awayVal: number) => {
  const total: number = homeVal + awayVal;

  const rsHome = ((homeVal / total) * 100).toFixed();
  const rsAway = ((awayVal / total) * 100).toFixed();

  return {
    home: rsHome,
    away: rsAway,
  };
};

const datas = computed(() => {
  const items: IData[] = [
    {
      title: "Điểm",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
    {
      title: "Bắt bóng bật bảng",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
    {
      title: "Đường chuyền kiến tạo",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
  ];

  if(props.lineups.players) {
    for (const player of props.lineups.players.home) {
      if(items[0].home === 0 || player.data.score > items[0].home) {
        items[0].home = player.data.score;
        items[0].home_player_id = player.id;
        items[0].home_player_name = player.name;
      }
      if(items[1].home === 0 || player.data.total_rebounds > items[1].home) {
        items[1].home = player.data.total_rebounds;
        items[1].home_player_id = player.id;
        items[1].home_player_name = player.name;
      }
      if(items[2].home === 0 || player.data.assists > items[2].home) {
        items[2].home = player.data.assists;
        items[2].home_player_id = player.id;
        items[2].home_player_name = player.name;
      }
    }
    for (const player of props.lineups.players.away) {
      if(items[0].away === 0 || player.data.score > items[0].away) {
        items[0].away = player.data.score;
        items[0].away_player_id = player.id;
        items[0].away_player_name = player.name;
      }
      if(items[1].away === 0 || player.data.total_rebounds > items[1].away) {
        items[1].away = player.data.total_rebounds;
        items[1].away_player_id = player.id;
        items[1].away_player_name = player.name;
      }
      if(items[2].away === 0 || player.data.assists > items[2].away) {
        items[2].away = player.data.assists;
        items[2].away_player_id = player.id;
        items[2].away_player_name = player.name;
      }
    }
  }

  return items;
});
</script>

<script lang="ts">
export default {};
</script>
